module.exports = __webpack_public_path__ + "close.svg?0e0917464985709146e1911309b47db9";